<!-- 此组件用于product页面的图片廊的展示 -->
<template>
  <el-carousel height="33.4vw">
    <el-carousel-item v-for="item in items" :key="item.url">
      <img :src="item.url" :alt="item.alt">
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: 'pictures',
  data () {
    return {
      items: [
        {
          url: require('../assets/product/test.png'),
          alt: 'test1'
        },
        {
          url: require('../assets/product/test1.png'),
          alt: 'test2'
        },
        {
          url: require('../assets/product/test2.png'),
          alt: 'test3'
        },
        {
          url: require('../assets/product/test3.png'),
          alt: 'test3'
        }
      ]
    }
  }
}
</script>

<style scoped>
  .el-carousel__item{
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
    vertical-align: middle;
  }
  img{
    display: block;
  }
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .el-carousel__item img{
    width:100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/pictures.vue